<template>
  <div class="supplier-edit">

    <v-form ref="formBasic" v-model="valid" lazy-validation>

      <v-container>
        <v-row>
          <v-col>

            <v-container class="pa-0">
              <v-row>
                <v-col class="py-0">
                  <v-text-field label="企業名" v-model="name" :readonly="isSystemLinked"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field label="システム登録CD" v-model="systemCd" :readonly="isSystemLinked"></v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col class="py-0">
                  <v-text-field label="住所1" v-model="address1" :readonly="isSystemLinked"></v-text-field>
                  <v-text-field label="住所2" v-model="address2" :readonly="isSystemLinked"></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-select
                      :items="areas"
                      label="エリア"
                      item-text="name"
                      item-value="cd"
                      v-model="areaCd"
                       :readonly="isSystemLinked"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col class="py-0">
                  <v-text-field label="代表者名" v-model="president"></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-col>

          <v-col>
            <v-sheet v-if="mainPhotoId">
              <div style="width:300px">
                <image-view :height="300" :width="300" :image-id="mainPhotoId"></image-view>
                <div class="d-flex">
                  <a href="#" class="ml-auto" v-on:click.prevent="onMainPhotoDelete">削除</a><a href="#" class="ml-3" v-on:click.prevent="onPhotoSelect">変更</a>
                </div>
              </div>
            </v-sheet>
            <v-sheet v-else class="ma-7 pa-7 d-flex align-center" outlined height="300" width="300">
              <v-btn class="mx-auto" tile outlined color="grey lighten-1" x-large v-on:click="onPhotoSelect">
                <v-icon large>mdi-camera</v-icon>
                <span>写真を追加</span>
              </v-btn>
            </v-sheet>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-0" cols="12" sm="6" md="3">
            <v-text-field label="TEL" v-model="tel" :readonly="isSystemLinked"></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="6" md="3">
            <v-text-field label="FAX" v-model="fax" :readonly="isSystemLinked"></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" md="6">
            <v-text-field label="URL" v-model="url"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="py-0" cols="12" sm="6" md="3">
            <v-text-field label="資本金" v-model="capital" suffix="万円"></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="6" md="3">
            <v-text-field label="従業員" v-model="employeeNum" suffix="人"></v-text-field>
          </v-col>
          <v-col class="py-0" cols="12" sm="6" md="3">
            <v-text-field label="総売上額" v-model="totalSales" suffix="万円"></v-text-field>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pb-0" cols="12">
            取り扱い
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="2">
            <v-checkbox label="森康" class="my-0" v-model="contractors" :value="'my1'" :readonly="isSystemLinked"></v-checkbox>
          </v-col>
          <v-col class="py-0" cols="12" sm="2">
            <v-checkbox label="エムワイ" class="my-0" v-model="contractors" :value="'my2'" :readonly="isSystemLinked"></v-checkbox>
          </v-col>
          <v-col class="py-0" cols="12" sm="2">
            <v-checkbox label="CMY" class="my-0" v-model="contractors" :value="'my3'" :readonly="isSystemLinked"></v-checkbox>
          </v-col>
          <v-col class="py-0" cols="12" sm="2">
            <v-checkbox label="エクセル" class="my-0" v-model="contractors" :value="'excel'" :readonly="isSystemLinked"></v-checkbox>
          </v-col>
        </v-row>


        <v-row>
          <v-col class="pb-0" cols="12">
            <span class="mr-2">営業窓口</span>
            <v-btn small v-on:click="openRepresentativeDialog(null)">追加</v-btn>
          </v-col>
        </v-row>

        <v-row class="mb-3">
          <v-col v-for="(tnt,idx) in representatives" :key="tnt.name" cols="4">
            <v-card>
              <v-list-item three-line>
                <v-list-item-content>
                  <v-list-item-title class="mb-1">
                    <span class="mr-2">{{ tnt.name }}</span>
                    <v-chip v-if="tnt.keyPerson == 1" x-small class="mb-1" color="green" text-color="white">キーパーソン
                    </v-chip>
                    <v-chip v-else x-small class="mb-1" color="gray" outlined>キーパーソン</v-chip>
                  </v-list-item-title>
                  <v-list-item-subtitle> {{ tnt.tel }}</v-list-item-subtitle>
                  <v-list-item-subtitle> {{ tnt.email }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-on:click="onDeleteRepresentative(idx,tnt)">mdi-close</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-card>

          </v-col>
        </v-row>

        <v-row>
          <v-col class="pb-0" cols="12">
            WEB会議
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="2">
            <v-checkbox label="Teams" class="my-0" v-model="applications" :value="'teams'"></v-checkbox>
          </v-col>
          <v-col class="py-0" cols="12" sm="2">
            <v-checkbox label="Zoom" class="my-0" v-model="applications" :value="'zoom'"></v-checkbox>
          </v-col>
        </v-row>

        <v-row>
          <v-col class="pb-0" cols="12">
            <span class="mr-2">主要取引先</span>
            <v-btn small v-on:click="openClientDialog">追加</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="(cstm,idx) in clients" :key="cstm.name" class="pb-0" cols="12" sm="6" md="4">
            <v-card>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="mb-1"> {{ cstm.name }}</v-list-item-title>
                  <v-list-item-subtitle> {{ cstm.remark }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-on:click="onDeleteClient(idx,cstm)">mdi-close</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="pb-0" cols="12" sm="6" md="3">
            <!-- <v-text-field label="森康売上比率" v-model.number="editData.sales_rate" suffix="%"></v-text-field> -->
          </v-col>
        </v-row>


        <v-row class="mt-5">
          <v-col class="pb-0" cols="12">
            <span class="mr-2">サプライヤー</span>
            <v-btn small v-on:click="openSubSupplierDialog">追加</v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col v-for="(sup,idx) in subSuppliers" :key="sup.name" class="pb-0" cols="12" sm="6" md="4">
            <v-card>
              <v-list-item two-line>
                <v-list-item-content>
                  <v-list-item-title class="mb-1"> {{ sup.name }}</v-list-item-title>
                  <v-list-item-subtitle> {{ sup.remark }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <v-icon v-on:click="onDeleteSubSupplier(idx,sup)">mdi-close</v-icon>
                </v-list-item-action>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>


        <v-row class="mt-5">
          <v-col class="pb-0" cols="12">
            <span class="mr-2">取扱品目</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="2" v-for="item in itemGroups" :key="item.cd">
            <v-checkbox :label="item.itemGroupName" class="my-0" v-model="sup_item_groups" :value="item.itemGroupCd"></v-checkbox>
          </v-col>
        </v-row>

        <v-row class="mt-5">
          <v-col class="pb-0" cols="12">
            <span class="mr-2">保有設備</span>
          </v-col>
        </v-row>
        <v-row>
          <v-col class="py-0" cols="12" sm="2" v-for="item in equipments" :key="item.cd">
            <v-checkbox :label="item.equipmentName" class="my-0" v-model="sup_equipments" :value="item.equipmentCd"></v-checkbox>
          </v-col>
        </v-row>

      </v-container>

    </v-form>


    <SubSupplierDialog ref="subSupplierDialog"></SubSupplierDialog>
    <CustomerDialog ref="customerDialog"></CustomerDialog>
    <RepresentativeDialog ref="representativeDialog"></RepresentativeDialog>
    <FileUploadDialog ref="fileUploadDialog"></FileUploadDialog>

  </div>
</template>
<script>
import BaseView from "../../components/BaseView";
import SubSupplierDialog from "@/views/supplier_edit/SubSupplierDialog";
import CustomerDialog from "@/views/supplier_edit/CustomerDialog";
import RepresentativeDialog from "@/views/supplier_edit/RepresentativeDialog";
import FileUploadDialog from "@/components/dialogs/FileUploadDialog";

export default {
  mixins: [BaseView],
  components: {
    SubSupplierDialog,
    CustomerDialog,
    RepresentativeDialog,
    FileUploadDialog
  },
  props: {
    value: {
      type: Object,
      required: true
    },
  },
  data: () => ({
    isInitialized: false,
    isFetched: false,
    isLoading: false,
    isDownloading: false,

    condition: {},
    pager: {},
    errors: {},

    areas: [
      {name: "小松", cd: "1"},
      {name: "金沢", cd: "2"},
      {name: "加賀", cd: "3"},
      {name: "富山", cd: "4"},
      {name: "福井", cd: "5"},
      {name: "関東", cd: "6"},
      {name: "関西", cd: "7"},
      {name: "その他", cd: "99"},
    ],

    valid: true,
    validateRules: {
      contentRules: [
        v => !!v || '内容は必須項目です',
        v => (v && v.length <= 1000) || '内容は1000文字以内で入力してください'
      ],
    },
  }),
  computed: {
    isSystemLinked(){
      return !!this.value.systemCd;
    },
    name: {
      get: function () {
        return this.value.name
      },
      set: function (v) {
        this.$emit("cng-name", v)
      }
    },
    systemCd: {
      get: function () {
        return this.value.systemCd
      },
      set: function (v) {
        this.$emit("cng-system_cd", v)
      }
    },
    address1: {
      get: function () {
        return this.value.address1
      },
      set: function (v) {
        this.$emit("cng-address1", v)
      }
    },
    address2: {
      get: function () {
        return this.value.address2
      },
      set: function (v) {
        this.$emit("cng-address2", v)
      }
    },
    address3: {
      get: function () {
        return this.value.address3
      },
      set: function (v) {
        this.$emit("cng-address3", v)
      }
    },
    areaCd: {
      get: function () {
        return this.value.areaCd
      },
      set: function (v) {
        this.$emit("cng-area_cd", v)
      }
    },
    tel: {
      get: function () {
        return this.value.tel
      },
      set: function (v) {
        this.$emit("cng-tel", v)
      }
    },
    fax: {
      get: function () {
        return this.value.fax
      },
      set: function (v) {
        this.$emit("cng-fax", v)
      }
    },
    url: {
      get: function () {
        return this.value.url
      },
      set: function (v) {
        this.$emit("cng-url", v)
      }
    },
    president: {
      get: function () {
        return this.value.president
      },
      set: function (v) {
        this.$emit("cng-president", v)
      }
    },
    mainPhotoId: {
      get: function () {
        return this.value.mainPhotoId
      },
      set: function (v) {
        this.$emit("cng-main_photo_id", v)
      }
    },
    applications: {
      get: function () {
        return this.value.applications
      },
      set: function (v) {
        this.logger.log("applications", v)
        this.$emit("cng-applications", v)
      }
    },

    sup_equipments: {
      get: function () {
        return this.value.equipments
      },
      set: function (v) {
        this.logger.log("sup_equipments", v)
        this.$emit("cng-equipments", v)
      }
    },

    sup_item_groups: {
      get: function () {
        return this.value.itemGroups;
      },
      set: function (v) {
        this.logger.log("sup_item_groups", v)
        this.$emit("cng-item_groups", v)
      }
    },

    contractors: {
      get: function () {
        return this.value.contractors
      },
      set: function (v) {
        this.logger.log("contractors", v)
        this.$emit("cng-contractors", v)
      }
    },

    capital: {
      get: function () {
        return this.value.capital
      },
      set: function (v) {
        this.$emit("cng-capital", v)
      }
    },
    employeeNum: {
      get: function () {
        return this.value.employeeNum
      },
      set: function (v) {
        this.$emit("cng-employee_num", v)
      }
    },
    totalSales: {
      get: function () {
        return this.value.totalSales
      },
      set: function (v) {
        this.$emit("cng-total_sales", v)
      }
    },
    mySales: {
      get: function () {
        return this.value.mySales
      },
      set: function (v) {
        this.$emit("cng-my_sales", v)
      }
    },

    subSuppliers: {
      get: function () {
        return this.value.subSuppliers
      },
    },

    clients: {
      get: function () {
        return this.value.clients
      },
    },

    representatives: {
      get: function () {
        return this.value.representatives
      },
    },


  },
  mounted: function () {
    this.setupConditions();
  },
  created: function () {
  },
  watch: {
    '$route': function (to, from) {
      this.setupConditions();
    },
  },
  methods: {
    setupConditions() {

    },

    fetchData(needDataFetch) {
      let self = this;
      if (!this.isInitialized) {
        this.fetchBasicData(function () {
          self.fetchData(needDataFetch)
        });
        return;
      }
      if (needDataFetch) {
        this.isLoading = true;
        Promise.resolve()
            .then(data => {
              //
            })
            .catch(function (err) {
              console.log(err);
              self.showErrorToast("データの取得に失敗しました。");
            });
      }
    },

    fetchBasicData(finishProc) {
      this.isInitialized = true;
      if (finishProc) {
        finishProc();
      }
    },


    async openSubSupplierDialog() {

      let data = {
        name: "",
        remark: "",
      }

      let dialogRef = await this.$refs.subSupplierDialog.open(data, {})
      if (dialogRef) {

        let rec = {
          name: dialogRef.name,
          remark: dialogRef.remark,
        }

        let list = this.subSuppliers;
        list.push(rec)

      }

    },

    onDeleteSubSupplier(idx, sup) {
      this.subSuppliers.splice(idx, 1)
    },


    async openClientDialog() {

      let data = {
        name: "",
        remark: "",
      }

      let dialogRef = await this.$refs.customerDialog.open(data, {})
      if (dialogRef) {

        let rec = {
          name: dialogRef.name,
          remark: dialogRef.remark,
        }

        let list = this.clients;
        list.push(rec)

      }

    },

    onDeleteClient(idx, cli) {
      this.clients.splice(idx, 1)
    },

    async openRepresentativeDialog(selectedData) {

      let data = {
        name: "",
        email: "",
        keyPerson: 0,
        tel: "",
      }

      if (selectedData) {
        data.name = selectedData.name
        data.email = selectedData.email
        data.keyPerson = selectedData.keyPerson
        data.tel = selectedData.tel
      }

      let dialogRef = await this.$refs.representativeDialog.open(data, {})
      if (dialogRef) {

        let rec = {
          name: dialogRef.name,
          email: dialogRef.email,
          keyPerson: dialogRef.keyPerson,
          tel: dialogRef.tel,
        }

        let list = this.representatives;
        list.push(rec)

      }

    },

    onDeleteRepresentative(idx, tnt) {
      this.representatives.splice(idx, 1)
    },

    async onPhotoSelect() {

      let files = await this.$refs.fileUploadDialog.open("写真選択", "", {})

      if (files) {
        let fileId = files[0];

        this.mainPhotoId = fileId;

      }

    },

    onMainPhotoDelete(){
      this.mainPhotoId = null;
    },


  },

}
</script>